var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.63 60.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 32.79,
    cy: 26.18,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M125.59,15.28c3.2-2.9,6.7-5.4,10.4-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M114.69,14.68c4.8-4.1,10-7.7,15.3-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131.69,41.88c3.2,2.9,5.8,4.7,9.4,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M121.79,43.18c4.8,4.1,7.7,6.4,13.1,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M52.49,50.58c1.2,1.3,2.6,2.4,4.3,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.59,50.48c1.2,1.3,2.6,2.4,4.3,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M163.19,25.68c3.9-.3,7-1.9,10.3-3.9,5.3-3.2,12.3-6,18.6-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M163.19,31.38c3.9,.3,7,1.9,10.3,3.9,5.3,3.2,12.3,6,18.6,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161.79,28.48c3.9,.1,7.8,.3,11.7,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M26.59,40.18c.6,.1,2,.6,3.3,1,3.3,.9,7.6,.9,8.2,.9,19.9,.4,78.4,1.5,86.2,.4,8.4-1.1,16.2-5.1,24.8-5.8,1.7-.1,3.4-.2,5.1-.1,6.3,.1,12.5,1.8,18,4.8,.9,.5,1.6,.9,2.1,1.1,3.3,1.2,6.5,2.5,10.1,3.3,2.1,.5,8.4,1.8,9.5,1.6,1.5-.4,2-1.4,1.2-2.8-1.9-3.2-2.7-6.7-6.3-9.5-2.8-2.1-7.3-3.7-8.2-6.5-1.1-3.1,4-4.8,7.1-6.9,1.2-.8,4-4.5,4-4.5,0,0,3.1-5.5,3.5-6.1,.9-1.5,.4-2.4-1.2-2.8-1.2-.2-7.4,1.1-9.5,1.6-5.2,1.2-8.9,3.2-12.8,5.3-1.5,.8-3,1.8-4.4,2.8-3.1,2.2-11,6.3-21.3,2.8-18.6-6.4-33.1-5.8-49.8-6.2-14.6-.3-22.9,0-35.8,.3-9.5,.2-19.2,.9-28.2,3.8-2.6,.8-4.3,2.1-5.6,2.9-4.6,2.7-13,5.6-15.9,6.3-4.3,1-7.5,3.5-8.6,5.2-1.2,1.9,10,4.6,24.5,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M45.69,16.78c6.1,5.9,6.9,14.1,2,19.5"
  }), /*#__PURE__*/React.createElement("text", null), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M103.89,14.18s15.3-10.8,17.9-12c0,0,4.2-.9,9.6,1.3,4.5,1.9,8.1,5.2,10.7,9.3l-7.2,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.09,43.18s13.5,9.6,16.2,10.9c0,0,4.2,.9,9.6-1.3,4.5-1.9,8.1-5.2,10.7-9.3l-7.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.79,42.68c.7,5.4,3.8,11.8,8.8,14.5,.9,.5,3.2,1,3.2,1l.5-9.5s-4.1-3.6-4.9-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M78.79,43.18c.7,5.4,3.8,11.8,8.8,14.5,.9,.5,3.2,1,3.2,1l.5-9.5s-4.1-3.6-4.9-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M42.09,31.38c.1,4.7-2.2,8.1-6.8,10.2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPike);
export default __webpack_public_path__ + "static/media/Pike.ee4a9619b0b105aa2ccf8eb9ecd8fca8.svg";
export { ForwardRef as ReactComponent };